import styles from "./Table.module.scss";
import type { ReactNode } from "react";

export interface TableColumn {
  key: string;
  label: ReactNode;
  suffix?: ReactNode;
}

interface TableHeaderProps {
  columns: readonly TableColumn[];
  onInfoClick?: (key: string) => void;
}

export function TableHeader({ columns, onInfoClick }: TableHeaderProps) {
  return (
    <div className={styles.tableHeader}>
      {columns.map(({ key, label, suffix }) => (
        <div key={key} className={styles.headerCell}>
          {label}
          {suffix && (
            <span
              className={styles.infoSuffix}
              onClick={() => onInfoClick?.(key)}
              role="button"
            >
              {suffix}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
